'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Selectors = require('../constants/Selectors');

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  default: '',
  'full-card': 'private-hoverlay--full-card',
  'bottom-half-card': 'private-hoverlay--bottom-half-card'
};

var UIHoverlay = _react2.default.createClass({
  displayName: 'UIHoverlay',

  propTypes: {
    _blur: _react.PropTypes.bool,
    children: _react.PropTypes.element,
    className: _react.PropTypes.string,
    foregroundContent: _react.PropTypes.node,
    hovered: _react.PropTypes.bool,
    href: _react.PropTypes.oneOfType([_validHref2.default]),
    linkComponent: CustomRenderer.propType,
    onClick: _react.PropTypes.func,
    overlayClassName: _react.PropTypes.string,
    tabIndex: _react.PropTypes.number,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _blur: true,
      linkComponent: _UILink2.default,
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasFocus: false,
      hasTabbableContent: false
    };
  },
  refCallback: function refCallback(el) {
    if (!el) {
      return;
    }
    var hasTabbableContent = el.querySelector(_Selectors.FOCUSABLE);
    this.setState({
      hasTabbableContent: hasTabbableContent
    });
  },
  handleBlur: function handleBlur() {
    this.setState({ hasFocus: false });
  },
  handleFocus: function handleFocus() {
    this.setState({ hasFocus: true });
  },
  handleMouseDown: function handleMouseDown(e) {
    e.preventDefault();
  },
  getChildrenClassName: function getChildrenClassName(_ref) {
    var _blur = _ref._blur;

    return (0, _reactUtils.classNames)('private-hoverlay__children', { 'private-hoverlay__children--blur': _blur }, { 'private-hoverlay--blur': _blur });
  },
  getOverlayClassName: function getOverlayClassName(_ref2) {
    var hasFocus = _ref2.hasFocus,
        href = _ref2.href,
        onClick = _ref2.onClick,
        overlayClassName = _ref2.overlayClassName;

    return (0, _reactUtils.classNames)(overlayClassName, 'uiOverlay-backdrop', 'private-hoverlay__overlay', 'private-overlay--contextual', {
      'private-hoverlay__overlay--clickable': href || onClick,
      'private-hoverlay__overlay--focused': hasFocus
    });
  },
  getOverlayContentClassName: function getOverlayContentClassName() {
    return (0, _reactUtils.classNames)('private-overlay__overlay-content', 'private-hoverlay__foreground-content');
  },
  renderLinkOverlay: function renderLinkOverlay(_ref3, _ref4) {
    var href = _ref3.href,
        linkComponent = _ref3.linkComponent;
    var renderedOverlay = _ref4.renderedOverlay;

    return CustomRenderer.render(linkComponent, {
      children: renderedOverlay,
      className: 'display-block',
      href: href,
      use: 'unstyled'
    });
  },
  renderButtonOverlay: function renderButtonOverlay(_ref5, _ref6) {
    var onClick = _ref5.onClick;
    var renderedOverlay = _ref6.renderedOverlay;

    return _react2.default.createElement(
      _UIClickable2.default,
      { className: 'private-hoverlay__button', onClick: onClick },
      renderedOverlay
    );
  },
  renderOverlay: function renderOverlay(_ref7) {
    var _blur = _ref7._blur,
        children = _ref7.children,
        foregroundContent = _ref7.foregroundContent,
        hasFocus = _ref7.hasFocus,
        hovered = _ref7.hovered,
        href = _ref7.href,
        onClick = _ref7.onClick,
        overlayClassName = _ref7.overlayClassName;

    var wrappedForegroundContent = foregroundContent == null ? null : _react2.default.createElement(
      'div',
      {
        className: this.getOverlayClassName({
          hasFocus: hasFocus,
          hovered: hovered,
          href: href,
          onClick: onClick,
          overlayClassName: overlayClassName
        }),
        onMouseDown: this.handleMouseDown
      },
      _react2.default.createElement(
        _UIFlex2.default,
        {
          align: 'stretch',
          direction: 'column',
          justify: 'start',
          className: this.getOverlayContentClassName()
        },
        foregroundContent
      )
    );

    return _react2.default.createElement(
      'span',
      null,
      wrappedForegroundContent,
      _react2.default.createElement(
        'div',
        { className: this.getChildrenClassName({ _blur: _blur }) },
        (0, _react.cloneElement)(children, {
          className: (0, _reactUtils.classNames)('private-hoverlay__child', children.props.className)
        })
      )
    );
  },
  render: function render() {
    var _props = this.props,
        _blur = _props._blur,
        className = _props.className,
        children = _props.children,
        foregroundContent = _props.foregroundContent,
        hovered = _props.hovered,
        href = _props.href,
        linkComponent = _props.linkComponent,
        onClick = _props.onClick,
        overlayClassName = _props.overlayClassName,
        tabIndex = _props.tabIndex,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['_blur', 'className', 'children', 'foregroundContent', 'hovered', 'href', 'linkComponent', 'onClick', 'overlayClassName', 'tabIndex', 'use']);

    var hasFocus = this.state.hasFocus;


    if (href && onClick) {
      _devLogger2.default.warn({
        message: 'UIHoverlay: Cannot have both onClick and href props.'
      });
    }

    var renderedOverlay = this.renderOverlay({
      _blur: _blur,
      children: children,
      foregroundContent: foregroundContent,
      hasFocus: hasFocus,
      hovered: hovered,
      href: href,
      onClick: onClick,
      overlayClassName: overlayClassName
    });
    var renderedHoverlay = void 0;
    if (href) {
      renderedHoverlay = this.renderLinkOverlay({ href: href, linkComponent: linkComponent }, { renderedOverlay: renderedOverlay });
    } else if (onClick) {
      renderedHoverlay = this.renderButtonOverlay({ onClick: onClick }, { renderedOverlay: renderedOverlay });
    } else {
      renderedHoverlay = renderedOverlay;
    }

    var classes = (0, _reactUtils.classNames)(className, 'private-hoverlay', USE_CLASSES[use], { 'is--module': use === 'full-card' });

    var computedTabIndex = void 0;
    if (tabIndex != null) {
      computedTabIndex = tabIndex;
    } else {
      computedTabIndex = this.state.hasTabbableContent ? null : 0;
    }

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: classes,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        ref: this.refCallback,
        tabIndex: computedTabIndex
      }),
      renderedHoverlay
    );
  }
});

exports.default = (0, _Hoverable2.default)(UIHoverlay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/overlay/UIHoverlay.js
// module id = 282
// module chunks = 0